import { render, staticRenderFns } from "./AllClient.vue?vue&type=template&id=4f585ef2"
import script from "./AllClient.vue?vue&type=script&lang=js"
export * from "./AllClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports